<template>

        <div class="custom-padding">
            <div class="container-fluid">

                <div class="row">
                    <div class="col-md-12 pl-0 pr-0 mt-3">
                    
                    <span class="heading-font-size"><i @click="backToStore()" class="fas fa-arrow-left mr-2"></i>{{storeName}}</span>
                    <img src="../assets/img/svg/Icon_awesome-check-circle.svg" class="img-fluid check-circle ml-3 mb-2" alt="Responsive image">
                </div>
                <div class="col-md-12 text-muted pl-0 pr-0">
                    <span class="comment-content">{{address}}</span>
                    <hr/>
                     </div>
                </div>

                <div class="row pb-3">
                    <div class="col">
                        <span><i class="fas fa-camera custom-text-color mr-2"></i><b>PHOTOS</b></span>
                    </div>
                    <div class="col">
                        <span class="custom-text-color float-right"><a ><b><i class="fas fa-plus-circle mr-2"></i>Add Photos</b></a></span>
                    </div>
                </div>
                <div class="row pt-3" v-for="item in items" :key="item.id">
                    <div class="col" v-for="portfolio in item[0].JSon8" :key="portfolio.id">
                        <a data-toggle="modal" data-target="#foodImage"><img v-bind:src="portfolio.MediaURL" class="img-fluid rounded cGalleryImage" alt="Responsive image"></a>
                        <!-- <div class="modal fade" id="foodImage" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content border-0">
            <span class="cross-button float-right">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </span>
            <div class="modal-body p-0">
                <div id="carouselExample" class="carousel slide" data-interval="false" >
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img class="d-block w-100" src="../assets/img/review-rating/image 31.svg">
                        </div>
                        <div class="carousel-item">
                            <img class="d-block w-100" src="../assets/img/review-rating/image 31.svg">
                        </div>
                        <div class="carousel-item">
                            <img class="d-block w-100" src="../assets/img/review-rating/image 31.svg">
                        </div>
                        <div class="carousel-item">
                            <img class="d-block w-100" src="../assets/img/review-rating/image 31.svg">
                        </div>
                    </div>
                    <a class="carousel-control-prev" href="#carouselExample" role="button" data-slide="prev">
                        <span aria-hidden="true"><i class="fa fa-2x fas fa-chevron-left"></i></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#carouselExample" role="button" data-slide="next">
                        <span aria-hidden="true"><i class="fa fa-2x fas fa-chevron-right"></i></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
                        </div>
                    </div> -->
                </div>
                
            </div>
        </div>
    </div>

</template>

<script>
export default {
  
  data : function(){
      return {
          storeName : sessionStorage.getItem('StoreName'),
          address : sessionStorage.getItem('StoreAddress'),
      }
  },
   computed:{
      items() {
        return this.$store.state.items
      }
    },
  methods: {
      backToStore: function(){
          this.$router.go(-1);
      }
  }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
